module.exports = __webpack_public_path__ + "static/img/rank_316.1664014.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_316.png
// module id = 2jnT
// module chunks = 1